import { useDispatch, useSelector } from "react-redux";
import svg19 from "../assets/svg/svg19.svg";
import { handleSideMenuCollapse } from "../features/global/globalSlice";
import { getSubdomain } from "../utils";
import SmartgateGlyph from "../components/SmartgateGlyph";
import { getAuthBrandConfig } from "../pages/auth/authBrand";

export default function SidebarBrand({ collapsed = false }) {
  const { user } = useSelector((state) => state.auth);
  const { balanceHeader } = useSelector((state) => state.menu);
  const { sideMenuCollapsed } = useSelector((state) => state.global);
  const dispatch = useDispatch();
  const subdomain = getSubdomain();
  const brandConfig = getAuthBrandConfig(subdomain);
  const brandName =
    user?.layer === "TOP" && subdomain === "smartgate"
      ? "Smartgate"
      : balanceHeader?.accName || "Workspace";

  const toggleSidebar = () => {
    dispatch(handleSideMenuCollapse(!sideMenuCollapsed));
  };

  return (
    <div
      className={`weiser-sidebar-brand ${
        collapsed ? "weiser-sidebar-brand-collapsed" : ""
      }`}
    >
      <div className="weiser-sidebar-brand-main">
        <div className="weiser-sidebar-brand-mark">
          {brandConfig.useSmartgateMark ? (
            <SmartgateGlyph className="weiser-smartgate-glyph" />
          ) : (
            <img src={brandConfig.logo} alt="brand logo" />
          )}
        </div>
        {!collapsed && (
          <span className="weiser-sidebar-brand-name dash-title">
            {brandName}
          </span>
        )}
      </div>
      <button
        type="button"
        onClick={toggleSidebar}
        className="weiser-sidebar-brand-toggle"
      >
        <img src={svg19} alt="toggle menu" />
      </button>
    </div>
  );
}
